export default {
  state: {
    loadersCount: 0,
  },

  mutations: {
    setLoadersCount(state, value) {
      value === "+" ? state.loadersCount++ : state.loadersCount--
    },
    resetLoaderCount(state) {
      state.loadersCount = 0
    }
  },
};
